import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-DialogClose",
  "use": "icon-DialogClose-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-DialogClose\">\r\n<rect x=\"2\" y=\"1\" width=\"11\" height=\"1.5\" transform=\"rotate(45 2 1)\" fill=\"#9296A3\" />\r\n<rect x=\"10\" y=\"2\" width=\"11\" height=\"1.5\" transform=\"rotate(135 10 2)\" fill=\"#9296A3\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol